export default __webpack_public_path__ + "static/db_meta_img-9ebd177607e23a484b298361ef499e13.jpg";